import { render } from "./KolViewPage.vue?vue&type=template&id=8704b81c&scoped=true"
import script from "./KolViewPage.vue?vue&type=script&lang=js"
export * from "./KolViewPage.vue?vue&type=script&lang=js"

import "./KolViewPage.vue?vue&type=style&index=0&id=8704b81c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8704b81c"

export default script